import React, { useEffect, useState } from 'react'
import './App.css'
import { Route, Routes } from 'react-router-dom'
import Login from './components/Login'
import SignUp from './components/SignUp'
import ResetPassword from './components/ResetPassword'
import ChangePassword from './components/ChangePassword'
import Passwordless from './components/Passwordless'
import LoginSuccess from './components/LoginSuccess'
import { ClientContext } from './context/client-context'
import { changeFavicon } from './helpers/change-favicon'
import { ConfirmEmail } from './components/ConfirmEmail'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import './CustomReactToastifyStyles.css'
import { ConfigAppService } from './services/config-app-service'
import MaintenanceMode from './components/MaintenanceMode'
import { resolveTenantFromWindow } from './helpers/resolve-tenant'
import { OAuthClientService } from './services/oauth-client-service'

function App () {
  const tenant = resolveTenantFromWindow()
  document.title = tenant.displayName
  changeFavicon(tenant.favicon)

  const [isMaintenanceMode, setIsMaintenanceMode] = useState(null)
  const [oauthError, setOauthError] = useState(null)

  useEffect(() => {
    const checkMaintenance = async () => {
      try {
        const maintenanceModeConfig =
          await ConfigAppService().isMaintenanceMode()
        setIsMaintenanceMode(maintenanceModeConfig)
      } catch (error) {
        console.error('Error:', error)
      }
    }
    checkMaintenance()
  }, [])

  useEffect(() => {
    const validateClient = async () => {
      const queryParams = new URLSearchParams(window.location.search)
      const clientId = queryParams.get('client_id') || sessionStorage.getItem('client_id')
      const redirectUri = queryParams.get('redirect_uri') || sessionStorage.getItem('redirect_uri')
      if (!clientId) return
      try {
        const result = await OAuthClientService().validateOAuthClient({
          clientId,
          redirectUri
        })
        if (result && result.valid === false) {
          setOauthError(result.error || 'Cliente OAuth no válido')
        }
      } catch (error) {
        // Do not block login if cms-rest is on legacy deploy without the endpoint yet
        console.warn('OAuth client validation skipped:', error?.message || error)
      }
    }
    validateClient()
  }, [])

  if (isMaintenanceMode === null) {
    return (
      <div className="main-loader">
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
      </div>
    )
  }

  if (isMaintenanceMode.isActive) {
    return <MaintenanceMode maintenanceMode={isMaintenanceMode} />
  }

  return (
    <>
      <ToastContainer />
      <div className={'App' + (tenant.themeClass ? ` theme-${tenant.themeClass}` : '')}>
        <div className="align-items-center container-size">
          <div className="row row-login justify-content-center">
            <div className="col-12 login-header text-center">
              <img
                alt={tenant.displayName}
                src={tenant.logoSrc}
                className={tenant.logoClass} />
            </div>
            <div className="col-sm-11 col-md-8 col-lg-7 col-xl-6 col-xxl-5">
              {oauthError && (
                <div className="alert alert-danger mx-3" role="alert">
                  {oauthError}
                </div>
              )}
              <ClientContext.Provider value={{
                tenant,
                isMiTienda: tenant.id === 'mi-tienda'
              }}>
                <Routes>
                  <Route path="/" element={<Login />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/signup" element={<SignUp />} />
                  <Route path="/confirm-email" element={<ConfirmEmail />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route path="/changepassword" element={<ChangePassword />} />
                  <Route path="/passwordless" element={<Passwordless />} />
                  <Route path="/login-success" element={<LoginSuccess />} />
                </Routes>
              </ClientContext.Provider>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default App
